import { useState } from "react";
import { toast } from "sonner";
import { adminApi } from "../../lib/adminApi";
import { useAuth } from "../../context/AuthContext";
import { Card, PageTitle, TextInput, Btn, run } from "../../components/admin/AdminUI";

export default function Account() {
  const { user } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v }));
  const submit = async () => {
    if (f.next.length < 10) return toast.error("New password must be at least 10 characters.");
    if (f.next !== f.confirm) return toast.error("New passwords don't match.");
    const r = await run(() => adminApi.post("/auth/change-password", { current_password: f.current, new_password: f.next }), "Password changed");
    if (r) setF({ current: "", next: "", confirm: "" });
  };
  return (
    <div data-testid="admin-account">
      <PageTitle eyebrow="Account" title="Your account" />
      <Card title="Change password" className="max-w-lg">
        <p className="text-sm text-slate-600 mb-4">Signed in as <strong data-testid="account-email">{user.email}</strong></p>
        <div className="space-y-4">
          <TextInput label="Current password" type="password" value={f.current} onChange={set("current")} testid="account-current-password" autoComplete="current-password" />
          <TextInput label="New password (min 10 characters)" type="password" value={f.next} onChange={set("next")} testid="account-new-password" autoComplete="new-password" />
          <TextInput label="Confirm new password" type="password" value={f.confirm} onChange={set("confirm")} testid="account-confirm-password" autoComplete="new-password" />
        </div>
        <Btn className="mt-5" onClick={submit} data-testid="account-change-password-button">Change password</Btn>
      </Card>
    </div>
  );
}
